import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  colspan: 1,
  style: {"width":"64px"}
}
const _hoisted_2 = ["colspan"]
const _hoisted_3 = { style: {"white-space":"nowrap"} }
const _hoisted_4 = ["data-cy", "onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_filter_bar = _resolveComponent("oss-filter-bar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn_ternary = _resolveComponent("v-btn-ternary")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isAuthorized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-3 justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAccountingItemEdition(false))),
                    block: "",
                    "data-cy": "accountingLogDocument-add"
                  }, {
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createTextVNode("Ajouter")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '6',
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_filter_bar, {
                    mode: 'document',
                    type: _ctx.type,
                    "onUpdate:type": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                    showTypeTag: false,
                    text: _ctx.search,
                    "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                    tags: _ctx.documentTags,
                    "onUpdate:tags": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.documentTags) = $event)),
                    startDate: _ctx.beginDate,
                    "onUpdate:startDate": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.beginDate) = $event)),
                    endDate: _ctx.endDate,
                    "onUpdate:endDate": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                    minDate: _ctx.minDate,
                    maxDate: _ctx.maxDate,
                    status: _ctx.documentStatus,
                    "onUpdate:status": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.documentStatus) = $event)),
                    showStatusTag: false,
                    statusIsManadatory: true,
                    dateIsManadatory: true,
                    thirdPartyCompanyName: _ctx.thirdPartyCompanyName,
                    "onUpdate:thirdPartyCompanyName": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.thirdPartyCompanyName) = $event)),
                    minPrice: _ctx.minAmount,
                    "onUpdate:minPrice": _cache[8] || (_cache[8] = ($event: any) => (
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? (_ctx.maxAmount = -$event + '')
                                : (_ctx.minAmount = $event + '')
                        )),
                    maxPrice: _ctx.maxAmount,
                    "onUpdate:maxPrice": _cache[9] || (_cache[9] = ($event: any) => (
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? (_ctx.minAmount = -$event + '')
                                : (_ctx.maxAmount = $event + '')
                        )),
                    limitMinPrice: 
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? -_ctx.maxDocumentAmount
                                : _ctx.minDocumentAmount
                        ,
                    limitMaxPrice: 
                            _ctx.documentType === 'PURCHASE_INVOICE'
                                ? -_ctx.minDocumentAmount
                                : _ctx.maxDocumentAmount
                        ,
                    "types-list": 
                            _ctx.logTypes.map((type) => {
                                return { value: type, text: _ctx.formatType(type) };
                            })
                        ,
                    "status-list": 
                            _ctx.allDocumentStatus.map((type) => {
                                return { value: type, text: _ctx.formatStatus(type) };
                            })
                        ,
                    companyId: _ctx.selectedCompany.id,
                    "data-cy": "AccountingLogDocument-filter"
                  }, null, 8, ["type", "text", "tags", "startDate", "endDate", "minDate", "maxDate", "status", "thirdPartyCompanyName", "minPrice", "maxPrice", "limitMinPrice", "limitMaxPrice", "types-list", "status-list", "companyId"])
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    outlined: "",
                    readonly: "",
                    "model-value": 'Débit : ' + _ctx.newCommonFormatCurrency(_ctx.totalDebit),
                    density: "compact"
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    outlined: "",
                    readonly: "",
                    "model-value": 'Crédit : ' + _ctx.newCommonFormatCurrency(_ctx.totalCredit),
                    density: "compact"
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.documentType !== 'MAIL')
            ? (_openBlock(), _createBlock(_component_v_data_table_server, {
                key: 0,
                headers: _ctx.headers,
                items: _ctx.documents,
                page: _ctx.pagination.page,
                "sort-by": _ctx.pagination.sortBy,
                "sort-desc": _ctx.pagination.descending,
                "items-per-page": _ctx.pagination.rowsPerPage,
                "items-length": _ctx.pagination.totalItems,
                "items-per-page-options": [5, 10, 25],
                loading: _ctx.loading,
                class: "table",
                "hide-default-footer": "",
                "fixed-header": "",
                height: "75vh",
                style: {"min-width":"1150px"},
                density: "compact"
              }, {
                headers: _withCtx(({ columns: headers }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_1, [
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.isAllSelected,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isAllSelected) = $event)),
                        indeterminate: 
                                    _ctx.selectedDocumentIds.length > 0 &&
                                    _ctx.selectedDocumentIds.length !== _ctx.documents.length
                                ,
                        color: "primary",
                        density: "compact",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "indeterminate"])
                    ]),
                    _createElementVNode("th", {
                      colspan: headers.length,
                      style: {"padding-left":"0"}
                    }, [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_ternary, {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openAccountingItemEdition(true))),
                                disabled: _ctx.disabledReversal,
                                class: "mr-3"
                              }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode(" Extourner ")
                                ])),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_menu, { "offset-y": "" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      (!_ctx.displayDeletePermanentlyButton)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 0,
                                            disabled: _ctx.disabledDelete,
                                            color: "error",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogDeleteSelectedDocument = true)),
                                            active: !_ctx.disabledDelete
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                  _createTextVNode("$delete")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                  _createTextVNode("Supprimer")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["disabled", "active"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.displayDeletePermanentlyButton)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 1,
                                            disabled: _ctx.disabledDeletePermanently,
                                            color: "red",
                                            onClick: _cache[13] || (_cache[13] = ($event: any) => (
                                                    _ctx.dialogDeletePermanentlySelectedDocument = true
                                                )),
                                            active: !_ctx.disabledDeletePermanently
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                  _createTextVNode("$delete")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                  _createTextVNode("Supprimer définitivement")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["disabled", "active"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_col, {
                            cols: "5",
                            class: "d-flex justify-end align-center pb-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.sortBy,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sortBy) = $event)),
                                items: _ctx.sortByList,
                                style: {"font-size":"0.75rem","width":"min-content"},
                                "hide-details": "",
                                "item-value": "key",
                                width: "30px",
                                prefix: "Trier par",
                                outlined: "",
                                "return-object": "",
                                density: "compact",
                                "item-title": (item) => item.text
                              }, null, 8, ["modelValue", "items", "item-title"]),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.pagination.rowsPerPage,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                items: [5, 10, 25],
                                "hide-details": "",
                                outlined: "",
                                style: {"font-size":"0.75rem","width":"min-content"},
                                width: "30px",
                                prefix: "Lignes par page",
                                density: "compact"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_3, _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage +
                                            _ctx.pagination.rowsPerPage) + " de " + _toDisplayString(_ctx.pagination.totalItems), 1),
                              _createVNode(_component_v_btn_prev, {
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.pagination.page--)),
                                disabled: _ctx.pagination.page === 1,
                                size: "small"
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_v_btn_next, {
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.pagination.page++)),
                                size: "small",
                                disabled: _ctx.nextPageDisabled
                              }, null, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_2)
                  ])
                ]),
                "no-data": _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("Aucune écriture trouvée")
                ])),
                item: _withCtx((props) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.accountingLines, (al, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: props.item.id + '_' + index,
                      style: {"cursor":"pointer"},
                      "data-cy": 'AccountingLogDocument-document-' + index,
                      onClick: ($event: any) => (_ctx.openDocument(props.item))
                    }, [
                      _createElementVNode("td", {
                        class: "text-center",
                        style: _normalizeStyle(_ctx.getCellStyle(index, 'width: 64px;'))
                      }, [
                        (index === 0)
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (_ctx.addSelectedDocument(props.item.id)), ["stop"]),
                              class: "pa-0 ma-0",
                              "hide-details": "",
                              ripple: false,
                              "model-value": _ctx.isSelected(props.item.id)
                            }, null, 8, ["onClick", "model-value"]))
                          : _createCommentVNode("", true)
                      ], 4),
                      (_ctx.documentType === 'ALL')
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: "pl-2 pr-2 text-center",
                            style: _normalizeStyle(_ctx.getCellStyle(index))
                          }, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.getDocumentLog(props.item)), 1))
                              : _createCommentVNode("", true)
                          ], 4))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", {
                        class: "px-0 text-center",
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, _toDisplayString(_ctx.formatDate(al.date)), 5),
                      _createElementVNode("td", {
                        class: "pl-2 pr-2 text-left",
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, _toDisplayString(_ctx.getAccountableAccountTitle(al)), 5),
                      _createElementVNode("td", {
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, [
                        (al.tag)
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              label: "",
                              color: "tagFree",
                              class: "mr-1",
                              size: "x-small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(al.tag.name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (al.tags)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(al.tags, (tag, tagIndex) => {
                              return (_openBlock(), _createBlock(_component_v_chip, {
                                label: "",
                                class: "mr-1",
                                key: tagIndex,
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                                  }, _toDisplayString(tag.name), 5)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(al.wording), 1)
                      ], 4),
                      _createElementVNode("td", {
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, _toDisplayString(props.item.invoiceNumber || ""), 5),
                      _createElementVNode("td", {
                        class: "text-left",
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, _toDisplayString(_ctx.getThirdPartyName(al)), 5),
                      _createElementVNode("td", {
                        class: "px-0 text-right",
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, [
                        (al.amountSigned > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(al.amountSigned))), 1))
                          : _createCommentVNode("", true)
                      ], 4),
                      _createElementVNode("td", {
                        class: "pl-0 pr-2 text-right",
                        style: _normalizeStyle(_ctx.getCellStyle(index))
                      }, [
                        (al.amountSigned < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(al.amountSigned))), 1))
                          : _createCommentVNode("", true)
                      ], 4)
                    ], 8, _hoisted_4))
                  }), 128))
                ]),
                _: 1
              }, 8, ["headers", "items", "page", "sort-by", "sort-desc", "items-per-page", "items-length", "loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.accountingItemEditionDialog,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.accountingItemEditionDialog) = $event)),
            actions: _ctx.actions,
            prefixDataCy: "AccountingLogDocument",
            width: "90vw"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_ctx.accountingItemEditionDialog)
                  ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                      key: 0,
                      inType: _ctx.editionLog,
                      inLogTagId: _ctx.editionLogTagId,
                      prefilledRows: _ctx.prefilledRows,
                      actions: _ctx.actions,
                      companyId: _ctx.selectedCompany.id,
                      onUpsert: _cache[18] || (_cache[18] = ($event: any) => {
                            _ctx.accountingItemEditionDialog = false;
                            _ctx.refresh();
                        })
                    }, null, 8, ["inType", "inLogTagId", "prefilledRows", "actions", "companyId"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "actions"]),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.dialogDeleteSelectedDocument,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dialogDeleteSelectedDocument) = $event)),
            title: "Supprimer des documents",
            validTitle: "Oui, je suis sûr(e)",
            "valid-class": "error",
            onValid: _ctx.deleteDocuments,
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", _hoisted_8, " Voulez-vous supprimer " + _toDisplayString(_ctx.selectedDocumentIds.length) + " document" + _toDisplayString(_ctx.selectedDocumentIds.length === 1 ? "" : "s") + " ? ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onValid"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}